import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex gap-2"
}
const _hoisted_2 = {
  key: 1,
  class: "flex gap-2"
}

import { useColorMode } from "@vueuse/core";
import { Button } from "@/components/landingPage/ui/button";
import { Moon, Sun } from "lucide-vue-next";

export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleTheme',
  setup(__props) {

const mode = useColorMode();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (mode.value = _unref(mode) === 'dark' ? 'light' : 'dark')),
    size: "sm",
    variant: "ghost",
    class: "w-full justify-start"
  }, {
    default: _withCtx(() => [
      (_unref(mode) == 'light')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(Moon), { class: "size-5" }),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "block lg:hidden" }, " Dark ", -1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_unref(Sun), { class: "size-5" }),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "block lg:hidden" }, "Light", -1))
          ])),
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "sr-only" }, "Toggle theme", -1))
    ]),
    _: 1
  }))
}
}

})